import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=475b2f7c&scoped=true"
import script from "./table-list.vue?vue&type=script&lang=js"
export * from "./table-list.vue?vue&type=script&lang=js"
import style0 from "./table-list.vue?vue&type=style&index=0&id=475b2f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b2f7c",
  null
  
)

export default component.exports